import config       from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

const BASE = `${config.API_URL}Beacon4Synthesis`;

export const GetBlendedSidePolygons = (platform, type, side = '') =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetSidePolygons`, params: { platform, type, side } });

export const GetBlendedKpiConfig = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetKpiConfig` });

export const GetBlendedKpiData = (params) =>
	AxiosRequest({
		method: 'GET',
		url:    `${BASE}/GetKpiData`,
		params: {
			platform: params.platform,
			type:     params.type,
			side:     params.side,
			// selectedPolygons [] = all; otherwise join as CSV
			polygons: Array.isArray(params.polygons) && params.polygons.length > 0
				? params.polygons.join(',')
				: '',
		},
	});

export const GetBlendedRagThresholds = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetRagThresholds` });